import { Component, OnInit } from '@angular/core'
import { LoadingService } from '../../service/loading/loading.service'
import { delay } from 'rxjs/operators'

@Component({
    selector: 'app-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.scss'],
    standalone: false
})
export class LayoutComponent implements OnInit {
  isLoading: boolean = false

  constructor(private loading: LoadingService) {}

  ngOnInit(): void {
    this.listenToLoading()
  }

  listenToLoading() {
    this.loading.loadingSub
      .pipe(delay(0)) // This prevents a ExpressionChangedAfterItHasBeenCheckedError for subsequent requests
      .subscribe((loading) => {
        this.isLoading = loading
      })
  }
}
